import axios from '@/utils/request';

// 获取车辆详情
export const getDetail = (id) => {
    return axios.get(`/system/car/getCarInfo/${id}`)
}

// 获取音视频回放
export const getPlaybackVideo = (params) => {
    return axios.get(`/system/car/getPlaybackVideo`,{params})
}